import script from "./LinkAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./LinkAttachment.vue?vue&type=style&index=0&id=1c3c8bb5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3c8bb5"]])

export default __exports__